// Texts for stat page
const statistics = {
  visitPerDayChartTitle: 'Visitas por día',
  visitPerDayChartXAxisName: 'Fecha',
  visitPerDayChartYAxisName: 'Cantidad de visitas',
  visitPerDayChartHoverXAxisName: 'Día',
  visitPerDayChartHoverYAxisName: 'Visitas',

  viewPerProductChartTitle: 'Visitas por producto',
  viewPerProductChartXAxisName: 'Producto',
  viewPerProductChartYAxisName: 'Cantidad de visitas',
  viewPerProductChartHoverXAxisName: 'Producto',
  viewPerProductChartHoverYAxisName: 'Visitas',

  viewPerLocationChartTitle: 'Visitas por ciudad',
  viewPerLocationChartXAxisName: 'Ciudad',
  viewPerLocationChartYAxisName: 'Cantidad de visitas',
  viewPerLocationChartHoverXAxisName: 'Ciudad',
  viewPerLocationChartHoverYAxisName: 'Visitas',
};

export default statistics